"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
require("./FileSelector.scss");
var FileSizeHelper_1 = require("../../helpers/FileSizeHelper");
var FileSelectorMode;
(function (FileSelectorMode) {
    FileSelectorMode[FileSelectorMode["standard"] = 0] = "standard";
    FileSelectorMode[FileSelectorMode["Button"] = 1] = "Button";
    FileSelectorMode[FileSelectorMode["Menu"] = 2] = "Menu";
})(FileSelectorMode = exports.FileSelectorMode || (exports.FileSelectorMode = {}));
exports.FileSelector = function (props) {
    var fileInput = react_2.useRef(null);
    var formRef = react_2.useRef(null);
    var extensionFilter = props.extensionFilter, labels = props.labels, selectedFile = props.selectedFile, onSelectFile = props.onSelectFile, onDownloadFile = props.onDownloadFile, uploadProgressState = props.uploadProgressState, onCancelUpload = props.onCancelUpload, onUnSelectFile = props.onUnSelectFile, onDeleteFile = props.onDeleteFile, readonly = props.readonly, classname = props.classname, errorMessage = props.errorMessage, mode = props.mode;
    var _a = react_2.useState(selectedFile), fileInfo = _a[0], setFileInfo = _a[1];
    var _b = react_2.default.useState(false), showContextualMenu = _b[0], setShowContextualMenu = _b[1];
    react_2.useEffect(function () {
        if (selectedFile) {
            setFileInfo(selectedFile);
        }
    }, [selectedFile]);
    var onChangedFile = function (ev) {
        var _a;
        if (((_a = ev.currentTarget.files) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            var fileObject = ev.currentTarget.files[0];
            var file = {
                file: fileObject,
                name: fileObject.name,
                size: fileObject.size,
            };
            setFileInfo(file);
            if (onSelectFile) {
                onSelectFile(file);
            }
        }
    };
    var viewFileContent = function (fileObject) {
        try {
            var fileReader_1 = new FileReader();
            fileReader_1.readAsArrayBuffer(fileObject);
            fileReader_1.onload = function () {
                var fileContent = fileReader_1.result;
                if (fileContent) {
                    var fileType = fileObject.type;
                    var blob = new Blob([fileContent], { type: fileType });
                    var url = URL.createObjectURL(blob);
                    window.open(url);
                    URL.revokeObjectURL(url);
                }
            };
        }
        catch (ex) {
            // eslint-disable-next-line no-console
            console.error(ex);
        }
    };
    var onViewFile = function () {
        if (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.file) {
            viewFileContent(fileInfo.file);
        }
    };
    var getFileSizeString = function (filesize) {
        if (filesize) {
            return "(" + FileSizeHelper_1.FileSizeToString(filesize) + ")";
        }
        return '';
    };
    var getUploadProgressStateString = function () {
        if (uploadProgressState) {
            if (uploadProgressState >= 1) {
                return "(100 %) ";
            }
            return "(" + Math.round(uploadProgressState * 100) + " %) ";
        }
        return '';
    };
    var buildMenuItems = function () {
        var menuItems = [];
        if (fileInfo && labels.chooseAnotherFile) {
            menuItems.push({
                key: 'chooseAnotherFile',
                text: labels.chooseAnotherFile,
                iconProps: { iconName: 'OpenFile' },
                onClick: function () {
                    if (fileInput.current) {
                        fileInput.current.click();
                    }
                },
            });
            if ((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.file) && labels.viewFile && !errorMessage) {
                menuItems.push({
                    key: 'viewFile',
                    text: labels.viewFile,
                    iconProps: { iconName: 'View' },
                    onClick: function () { return onViewFile(); },
                });
            }
            if ((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.url) && labels.downloadFile && !errorMessage) {
                menuItems.push({
                    key: 'downloadFile',
                    text: labels.downloadFile + " " + getFileSizeString(fileInfo.size),
                    iconProps: { iconName: 'Download' },
                    onClick: function () {
                        if (onDownloadFile) {
                            onDownloadFile(fileInfo);
                        }
                    },
                });
            }
            if ((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.url) && labels.deleteFile) {
                menuItems.push({
                    key: 'deleteFile',
                    text: labels.deleteFile,
                    iconProps: { iconName: 'Delete' },
                    onClick: function () {
                        if (onDeleteFile) {
                            onDeleteFile(fileInfo);
                        }
                    },
                });
            }
            if (fileInfo && labels.unSelectFile) {
                menuItems.push({
                    key: 'unselectFile',
                    text: labels.unSelectFile,
                    iconProps: { iconName: 'Cancel' },
                    onClick: function () {
                        setFileInfo(undefined);
                        if (formRef.current) {
                            formRef.current.reset();
                            if (onUnSelectFile) {
                                onUnSelectFile();
                            }
                        }
                    },
                });
            }
        }
        return menuItems;
    };
    var menuProps = {
        shouldFocusOnMount: true,
        items: buildMenuItems(),
    };
    var currentMode = mode !== null && mode !== void 0 ? mode : FileSelectorMode.standard;
    return (react_2.default.createElement("div", { className: clsx_1.default('eta-fileSelector', classname) },
        react_2.default.createElement("form", { ref: formRef },
            react_2.default.createElement("div", null,
                react_2.default.createElement("input", { type: "file", name: "file", multiple: false, accept: extensionFilter, ref: fileInput, onChange: onChangedFile })),
            react_2.default.createElement("div", null,
                ((!fileInfo || currentMode === FileSelectorMode.Button) && !readonly) && (react_2.default.createElement(react_1.DefaultButton, { iconProps: { iconName: 'OpenFile' }, className: clsx_1.default('fileSelection', currentMode === FileSelectorMode.Button ? 'noBorder' : ''), text: labels.selectFile, onClick: function () {
                        if (fileInput.current) {
                            fileInput.current.click();
                        }
                    } })),
                ((!fileInfo || currentMode === FileSelectorMode.Button) && readonly) && (react_2.default.createElement("div", { className: clsx_1.default('fileSelection readonly', currentMode === FileSelectorMode.Button ? 'noBorder' : '', errorMessage ? 'error' : '') },
                    react_2.default.createElement("div", { className: "filePlaceHolder" }))),
                (fileInfo && currentMode === FileSelectorMode.standard) && (react_2.default.createElement("div", { className: clsx_1.default('fileSelection', errorMessage ? 'error' : '', readonly ? 'readonly' : '') },
                    react_2.default.createElement("div", { className: "filePlaceHolder" },
                        react_2.default.createElement(react_1.Icon, { iconName: "TextDocument", className: "icon" }),
                        react_2.default.createElement(react_1.Label, { className: clsx_1.default('text', fileInfo.url ? 'clickable' : ''), title: "" + getUploadProgressStateString() + fileInfo.name + " " + getFileSizeString(fileInfo.size), onClick: function () {
                                if (onDownloadFile && fileInfo.url) {
                                    onDownloadFile(fileInfo);
                                }
                            } }, "" + getUploadProgressStateString() + fileInfo.name + " " + getFileSizeString(fileInfo.size),
                            ' '),
                        uploadProgressState === undefined && !readonly && (react_2.default.createElement(react_1.IconButton, { className: "iconMenu", menuIconProps: { iconName: 'MoreVertical' }, menuProps: menuProps, onClick: function () { return setShowContextualMenu(!showContextualMenu); } })),
                        uploadProgressState !== undefined &&
                            labels.cancelUpload &&
                            onCancelUpload && (react_2.default.createElement(react_1.IconButton, { className: "iconMenu", title: labels.cancelUpload, iconProps: { iconName: 'Cancel' }, onClick: function () {
                                if (onCancelUpload) {
                                    onCancelUpload();
                                }
                            } }))),
                    uploadProgressState !== undefined && (react_2.default.createElement(react_1.ProgressIndicator, { percentComplete: uploadProgressState })))),
                (fileInfo && !readonly && currentMode === FileSelectorMode.Menu) && (react_2.default.createElement(react_1.IconButton, { className: "iconMenu", menuIconProps: { iconName: 'MoreVertical' }, menuProps: menuProps, onClick: function () { return setShowContextualMenu(!showContextualMenu); } })),
                errorMessage && react_2.default.createElement(react_1.Label, { className: "error" }, errorMessage)))));
};
//# sourceMappingURL=FileSelector.js.map